import React, { useState, useRef, useEffect, useCallback } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { motion } from "framer-motion";

import i18n from "../../../i18n";

const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');
const index = client.initIndex('Reaction');



const _fetchReactions = async ({ page = 0, moment_id = '', emotionKey = null }) => {
  const index = client.initIndex('Reaction');

  const filters = emotionKey ? `story_id:${moment_id} AND category:${emotionKey}` : `story_id:${moment_id}`; // adapte selon ton besoin

  const { hits, nbPages, page: currentPage, nbHits } = await index.search('*', {
    page,
    hitsPerPage: 20,
    filters,
  });

  return { hits, nbPages, currentPage, nbHits };
};


const EMOTIONS = {
  Like: { label: "Like", icon: "/img/em_blove.png" },
  Inspiring: { label: "Inspiring", icon: "/img/em_inspiring.png" },
  Sad: { label: "Sad", icon: "/img/em_bface.png" },
  Angry: { label: "Angry", icon: "/img/em_angry.png" },
  Happy: { label: "Happy", icon: "/img/em_bjoy.png" },
  Thoughtful: { label: "Thoughtful", icon: "/img/em_bthinking.png" },
  Connected: { label: "Connected", icon: "/img/em_connexion.png" },
};

export default function ReactionPopup({moment_id, reactions, updatedEmotion, width, height, onClose }) {





  const [activeTab, setActiveTab] = useState('All');
  const [grouped, setGrouped] = useState({});
  const [reactionsByTab, setReactionsByTab] = useState({});
  const [pageByTab, setPageByTab] = useState({});
  const [hasMoreByTab, setHasMoreByTab] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [displayed, setDisplayed] = useState([]);
  const contentRef = useRef(null);
  const loadingRef = useRef(false);

  const reactionCache = useRef({});


  useEffect(() => {
    const groupedData = reactions.reduce((acc, item) => {
      const key = item.key;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
    setGrouped(groupedData);



  }, [moment_id, reactions]);


  /* useEffect(() => {
      // 1. Reset le cache et les états liés aux pages/réactions
      reactionCache.current = {};
      setReactionsByTab({});
      setPageByTab({});
      setHasMoreByTab({});
      setDisplayed([]);

      // 2. Re-group les données locales (si toujours nécessaire)
      const groupedData = reactions.reduce((acc, item) => {
        const key = item.key;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});
      setGrouped(groupedData);

      // 3. Refetch pour le tab actif
      fetchReactions(activeTab, 0, reactions);


  }, [reactions, activeTab, fetchReactions]); */



  useEffect(() => {
  if (!updatedEmotion) return;

  const fetchAndInjectNewReaction = async () => {
      if (updatedEmotion.typef === "remove")
      {
           removeReactionById(updatedEmotion.id);
      }
      else if (updatedEmotion.typef === "switch")
      {
          updateReactionCategory(updatedEmotion.id, updatedEmotion.category);
      }
      else
      {
              try {
                const { hits } = await index.search('', {
                  filters: `searchable_id:${updatedEmotion.id}`,
                  hitsPerPage: 1,
                });

              //  alert(' >> new >>> ' + JSON.stringify(updatedEmotion) + ' //// ' + JSON.stringify(hits))

                if (!hits.length) return;
                const newReaction = hits[0];

                // ⚠️ Vérifie que l'élément n’est pas déjà là (évite le doublon)
                const alreadyExists = (reactionCache.current["All"] || []).some(
                  (item) => item.objectID === newReactionId
                );
                if (alreadyExists) return;

                // Injecte en tête
                reactionCache.current["All"] = [newReaction, ...(reactionCache.current["All"] || [])];

                setReactionsByTab((prev) => ({
                  ...prev,
                  All: [newReaction, ...(prev.All || [])],
                }));

                if (activeTab === "All") {
                  setDisplayed((prev) => [newReaction, ...prev]);
                }

              } catch (err) {
                console.error('Erreur lors de la récupération de la nouvelle réaction :', err);
              }
        }
    };

    fetchAndInjectNewReaction();
  }, [updatedEmotion, activeTab]);


  const removeReactionById = (idToRemove) => {
    // 1. Nettoyer le cache
    reactionCache.current["All"] = (reactionCache.current["All"] || []).filter(
      (item) => item.objectID !== idToRemove
    );

    //alert('Remove >>> ' + idToRemove)

    // 2. Nettoyer le state reactionsByTab
    setReactionsByTab((prev) => ({
      ...prev,
      All: (prev.All || []).filter((item) => item.objectID !== idToRemove),
    }));

    // 3. Si on est sur le tab All, on nettoie aussi le displayed
    if (activeTab === "All") {
      setDisplayed((prev) => prev.filter((item) => item.objectID !== idToRemove));
    }
  };


  const updateReactionCategory = (objectID, newCategory) => {
      // 1. Met à jour dans le cache
      reactionCache.current["All"] = (reactionCache.current["All"] || []).map((item) =>
        item.objectID === objectID ? { ...item, category: newCategory } : item
      );

      //alert('Remove >>> ' + idToRemove + ' >>> ' + newCategory)

      // 2. Met à jour dans reactionsByTab.All
      setReactionsByTab((prev) => ({
        ...prev,
        All: (prev.All || []).map((item) =>
          item.objectID === objectID ? { ...item, category: newCategory } : item
        ),
      }));

      // 3. Si on est sur le tab All, met aussi à jour displayed
      if (activeTab === "All") {
        setDisplayed((prev) =>
          prev.map((item) =>
            item.objectID === objectID ? { ...item, category: newCategory } : item
          )
        );
      }
    };


  const fetchReactions = useCallback(async (tab, page = 0, reactions = null) => {



   if (page === 0 && reactionCache.current[tab]) {
     //alert('Yoooo 1')
      setReactionsByTab((prev) => ({
        ...prev,
        [tab]: reactionCache.current[tab],
      }));
      //alert('Yoooo 2')

      if (reactions !== null)
      {
        // alert('>>> A. ' + reactions.length + ' ??? ' + JSON.stringify(reactionCache.current['All']));
      }

      return;
    }


    loadingRef.current = true;
    setIsLoading(true);
    const filter = tab === 'All' ? `story_id:${moment_id}` : `story_id:${moment_id} AND category:${tab}`;



    const { hits, nbPages, nbHits } = await index.search('*', {
      filters: filter,
      page,
      hitsPerPage: 20,
    });

    if (reactions !== null)
    {
      // alert('>>> B. ' + reactions.length + ' ??? ' + JSON.stringify(reactionCache.current['All'])+ ' //// ' + nbHits);
     }


    /*const updatedReactions = [...(reactionsByTab[tab] || []), ...hits];

    if (page === 0) {
      reactionCache.current[tab] = updatedReactions;
    } */

    let updatedReactions;

    if (page === 0) {
      updatedReactions = hits; // 🧼 On écrase les anciennes données
      reactionCache.current[tab] = hits;

    } else {
      updatedReactions = [...(reactionsByTab[tab] || []), ...hits];
    }

    setReactionsByTab((prev) => ({
      ...prev,
      [tab]: updatedReactions,
    }));

    setPageByTab((prev) => ({
      ...prev,
      [tab]: page,
    }));

    setHasMoreByTab((prev) => ({
      ...prev,
      [tab]: page + 1 < nbPages,
    }));

    loadingRef.current = false;
    setIsLoading(false);
  }, [moment_id, updatedEmotion, reactions, activeTab, reactionsByTab]);


  useEffect(() => {
    if (!reactionsByTab[activeTab]) {
      fetchReactions(activeTab, 0, null);
    }
    else {
      setDisplayed(reactionsByTab[activeTab]);
    }
  }, [activeTab, fetchReactions, reactionsByTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setTimeout(() => {
      contentRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
  };

  const handleScroll = () => {
    const el = contentRef.current;
    if (!el || loadingRef.current || isLoading) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && hasMoreByTab[activeTab]) {
      fetchReactions(activeTab, (pageByTab[activeTab] || 0) + 1, null);
    }
  };

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);



  const availableKeys = Object.keys(grouped);


  const tabs = ["All", ...availableKeys];




  let marginTop;

  if (isMobileOnly)
  {
    marginTop = '125px';
  }
  else if (isTablet)
  {
     marginTop = '110px';
  }
  else
  {
     marginTop = '98px';
  }




  return (
    <div style={{width: '100%', height: 'auto'}}>




        {isMobileOnly &&
          <div className="tabs" style={{position: 'fixed', zIndex: 3, top: '50px', width: '100%', backgroundColor: '#fff'}}>
            {tabs.map((key) => (
              <button
                key={key}
                onClick={() => handleTabClick(key)}
                className={`tab-button-phone ${activeTab === key ? "active" : ""}`}
                style={{width: width/8+'px'}}
              >
                {key === "All" ? (
                  i18n.t("All_fem")
                ) : (
                  <span className="tab-icon-phone">
                     <span className="icon-phone">
                       <img src={EMOTIONS[key].icon} alt={key} className="reaction-img" />
                    </span>

                    <span className="count">{grouped[key]?.length || 0}</span>
                  </span>
                )}
              </button>
            ))}
         </div>
       }


       {!isMobileOnly &&
         <div className="tabs" style={{position: 'fixed', zIndex: 3, top: '50px', width: '100%', backgroundColor: '#fff'}}>
           {tabs.map((key) => (
             <button
               key={key}
               onClick={() => handleTabClick(key)}
               className={`tab-button ${activeTab === key ? "active" : ""}`}
               style={{width: width/8+'px'}}
             >
               {key === "All" ? (
                 i18n.t("All_fem")
               ) : (
                 <span className="tab-icon">
                    <span className="icon">
                      <img src={EMOTIONS[key].icon} alt={key} className="reaction-img" />
                   </span>

                   <span className="count">{grouped[key]?.length || 0}</span>
                 </span>
               )}
             </button>
           ))}
        </div>
      }




        <div className="popup-content" ref={contentRef} onScroll={handleScroll} style={{marginTop: marginTop, height: 'auto'}}>

          {displayed.length === 0 ? (
            <div>
               {!isLoading && (
                  <p className="no-reactions" style={{fontSize: '18px', color: '#333', marginTop: '60px'}}>{i18n.t('No_reactions')}</p>
                )}
            </div>
          ) : (
            displayed.map((user, index) => (
              <div key={user.user_id+'_'+index} style={{width: width+'px', height: '80px'}}>
                  <View style={{width: width+'px', height: '80px', display: 'flex', flexDirection: 'row'}}>

                         <View style={{marginLeft: 10, width: 62, height: 80, justifyContent: 'center'}}>
                            <View style={{width: 60, height: 60, borderRadius: 30, backgroundColor: '#28434d'}}><Image source={{uri: user.user_picture.replace('/pictures/normal/missing.png','/img/default_avatar_normal.png')}} style={{width: 60, height: 60, borderRadius: 30, borderWidth: 1, borderColor: '#ccc'}}/></View>
                         </View>
                         <View style={{marginLeft: 10, width: (width-30-60)+'px', height: 80, justifyContent: 'center'}}>
                              {user.user_sigle !== null && user.user_sigle !== undefined && user.user_sigle !== "" && <Text numberOfLines={1} style={{fontSize: '17px', color:'#111', fontWeight: '800'}}>{user.user_sigle}</Text>}
                              {(user.user_sigle === null || user.user_sigle === undefined || user.user_sigle === "") && <Text numberOfLines={1} style={{fontSize: '17px', color:'#111', fontWeight: '800'}}>{user.user_name}</Text>}
                              <Text numberOfLines={1} style={{fontSize: '15px', color:'#555'}}>{user.user_screenname}</Text>
                         </View>

                  </View>
              </div>
            ))
          )}

          {isLoading &&
             <div className="loading" style={{marginTop: '30px'}}>
                <View style={{width: '100%', height: '40px', alignItems: 'center', justifyContent: 'center'}}>
                   <ActivityIndicator animating={true} color="#555" />
                </View>
             </div>
          }
        </div>


    </div>
  );
}
